import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getNewStripeConfigOperation } from '../../operations/spaces_operations';
import { SMORG_STUDIO_SPACE_EDIT_ROUTE } from '../../services/routes';
import {
  useGetSpaceQuery,
  useUpdateSpacePrivateConfigMutation,
} from '../../app/smorgAppSyncGraphQLApi';
import { healthProGroupForSpaceID } from '../../services/users';
import { useGetOrCreateSpacePrivateConfigQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';

/**
 * Stripe OAuth process redirects to here
 * with the authorization code in the 'code' parameter in the URL
 */
const SpaceStripeConnectContainer = () => {
  const [searchParams] = useSearchParams();
  const authorizationCode = searchParams.get('code');

  const navigate = useNavigate();

  const { data: healthProSpace } = useGetSpaceQuery();

  const spaceID = healthProSpace?.id;

  const currentHealthProGroup =
    healthProSpace && healthProGroupForSpaceID(healthProSpace.id);

  const { data: spacePrivateConfig } = useGetOrCreateSpacePrivateConfigQuery(
    { spaceID, currentHealthProGroup },
    { skip: !spaceID },
  );

  const [updateSpacePrivateConfig] = useUpdateSpacePrivateConfigMutation();

  useEffect(() => {
    if (!spacePrivateConfig?.id) {
      console.error('No space private config found');
      return;
    }
    if (authorizationCode) {
      console.log(authorizationCode);
      getNewStripeConfigOperation(authorizationCode).then((newStripeConfig) => {
        if (newStripeConfig) {
          console.log(JSON.stringify(newStripeConfig));
          const updatedSpacePrivateConfig = {
            ...(spacePrivateConfig || {}),
            stripeConfig: newStripeConfig,
          };
          updateSpacePrivateConfig(updatedSpacePrivateConfig).finally(() => {
            navigate(SMORG_STUDIO_SPACE_EDIT_ROUTE, { replace: true });
          });
        }
      });
    }
  }, [
    spacePrivateConfig?.id,
    authorizationCode,
    navigate,
    spacePrivateConfig,
    updateSpacePrivateConfig,
  ]);
};

export default SpaceStripeConnectContainer;
